var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card-meal',{attrs:{"title":_vm.name,"images-src":_vm.images}},[_c('card-meal-action-remove',{on:{"click":_vm.showDislikesPopup}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }